import type { InsuranceCarrier } from "@/core/types";
import { InsuranceCarrierEnum } from "@/core/constants";

export const EXCLUDED_SECONDARY_CARRIERS: InsuranceCarrier[] = [
  InsuranceCarrierEnum.EDDY_SENIOR_CARE,
] as const;

export const SEC = "SEC";
export const PRI = "PRI";
